(function () {
  if (window.PFCartDrawer) return;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const inner = () => document.querySelector('#CartDrawer .drawer__inner');
  const setBusy = (b) => { const el = inner(); if (el) el.classList.toggle('pf-busy', b); };
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };
  let autoTried = false;

  async function post(path, body) {
    const res = await fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json();
    if (!res.ok) throw json;
    return json;
  }

  function showError(err) {
    const box = document.getElementById('CartDrawer-CartErrors');
    const msg = (err && (err.description || err.message)) || (window.cartStrings && window.cartStrings.error) || 'Erreur';
    if (box) box.textContent = msg;
    console.error(err);
  }

  /* ---------- Eén regel: tekst verkleint tot hij past ---------- */
  const FIT_TARGETS = '[data-pf-fit], #pf-sale-bar, #CartDrawer .pf-tiers__text';
  const FIT_MIN = 10;
  function fitOne(box) {
    let txt = box.querySelector('.pf-banner__inner, .pf-sale-text, .pf-fit__inner');
    if (!txt) {
      txt = document.createElement('span');
      txt.className = 'pf-fit__inner';
      while (box.firstChild) txt.appendChild(box.firstChild);
      box.appendChild(txt);
    }
    if (getComputedStyle(txt).display === 'inline') txt.style.display = 'inline-block';
    txt.style.whiteSpace = 'nowrap';
    txt.style.fontSize = '';
    const cs = getComputedStyle(box);
    const avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (avail <= 0) return;
    let size = parseFloat(getComputedStyle(txt).fontSize);
    let guard = 0;
    while (txt.getBoundingClientRect().width > avail + 0.5 && size > FIT_MIN && guard++ < 60) {
      size -= 0.5;
      txt.style.fontSize = size + 'px';
    }
    if (txt.getBoundingClientRect().width > avail + 0.5) txt.style.whiteSpace = 'normal';
  }
  function fitAll() { document.querySelectorAll(FIT_TARGETS).forEach(fitOne); }

  /* ---------- Voortgangsbalk ---------- */
  let shownFill = parseFloat(store.get('pf_fill_shown'));
  if (isNaN(shownFill)) shownFill = 0;
  let playTimer = null;
  const isOpen = () => { const d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('active')); };
  const getFill = () => document.querySelector('#CartDrawer .pf-tiers__fill');
  function paint(fill, w) { fill.style.transition = 'none'; fill.style.width = w + '%'; void fill.offsetWidth; fill.style.transition = ''; }
  function hold() { const f = getFill(); if (f) paint(f, shownFill); }
  function play() {
    const f = getFill();
    if (!f) { shownFill = 0; store.set('pf_fill_shown', '0'); return; }
    const to = parseFloat(f.dataset.width) || 0;
    paint(f, shownFill);
    requestAnimationFrame(() => requestAnimationFrame(() => { f.style.width = to + '%'; }));
    shownFill = to;
    store.set('pf_fill_shown', String(to));
  }
  function onRender() {
    fitAll();
    clearTimeout(playTimer);
    if (isOpen()) playTimer = setTimeout(play, 60);
    else hold();
  }

  /* ---------- Verzendbescherming ---------- */
  async function ensureProtection() {
    const state = document.querySelector('#CartDrawer .pf-state');
    if (!state) return false;
    const count = state.dataset.count;
    const key = state.dataset.protectKey;
    // Weg als er geen andere producten meer zijn, of als de sectie is uitgezet in de instellingen
    if (key && (count === '0' || state.dataset.protectOff === '1')) {
      await post('cart/change.js', { id: key, quantity: 0 });
      return true;
    }
    if (count !== '0' && !key && state.dataset.auto === '1' && state.dataset.protectVariant && !autoTried) {
      autoTried = true;
      await post('cart/add.js', { items: [{ id: parseInt(state.dataset.protectVariant, 10), quantity: 1 }] });
      return true;
    }
    return false;
  }

  async function refresh() {
    const res = await fetch(root() + '?sections=cart-drawer,cart-icon-bubble');
    const sections = await res.json();
    const parser = new DOMParser();
    if (sections['cart-drawer']) {
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const src = doc.querySelector('.drawer__inner');
      const target = inner();
      if (src && target) target.innerHTML = src.innerHTML;
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const src = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
    try { if (await ensureProtection()) return refresh(); } catch (e) { console.error(e); }
  }

  async function run(task) {
    setBusy(true);
    try { await task(); } catch (e) { showError(e); }
    try { await refresh(); } catch (e) { console.error(e); }
    setBusy(false);
  }

  /* ---------- Variant-kiezer in de cart ---------- */
  function pickerData(item) {
    const pick = item.querySelector('.pf-vpick');
    const dataEl = item.querySelector('.pf-vdata');
    if (!pick || !dataEl) return null;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    const current = variants.find((v) => String(v.id) === pick.dataset.variant);
    return { pick, variants, current };
  }

  function markAvailability(item) {
    const d = pickerData(item);
    if (!d || !d.current) return;
    const lastIdx = d.current.o.length - 1;
    item.querySelectorAll('.pf-vopt').forEach((btn) => {
      const i = parseInt(btn.dataset.index, 10);
      const val = btn.dataset.value;
      const combo = d.current.o.slice();
      combo[i] = val;
      const exact = d.variants.find((v) => v.o.every((x, k) => x === combo[k]));
      let ok = !!(exact && exact.a);
      if (!ok && i < lastIdx) ok = d.variants.some((v) => v.a && v.o[i] === val);
      btn.classList.toggle('is-unavailable', !ok);
      btn.disabled = !ok && !btn.classList.contains('is-selected');
    });
  }

  function closePanels(except) {
    document.querySelectorAll('#CartDrawer .pf-vpanel:not([hidden])').forEach((p) => {
      if (p === except) return;
      p.hidden = true;
      const b = document.querySelector('#CartDrawer [aria-controls="' + p.id + '"]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function swapVariant(pick, newId) {
    const qty = parseInt(pick.dataset.quantity, 10) || 1;
    let properties = {};
    try { properties = JSON.parse(pick.dataset.properties || '{}') || {}; } catch (e) {}
    run(async () => {
      const it = { id: newId, quantity: qty };
      if (properties && Object.keys(properties).length) it.properties = properties;
      await post('cart/add.js', { items: [it] });
      await post('cart/change.js', { id: pick.dataset.key, quantity: 0 });
    });
  }

  document.addEventListener('click', (event) => {
    const t = event.target;
    if (!t || !t.closest) return;

    const btn = t.closest('#CartDrawer .pf-vbtn');
    if (btn && btn.tagName === 'BUTTON') {
      event.preventDefault();
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      const open = panel.hidden;
      closePanels(panel);
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) markAvailability(btn.closest('.pf-item'));
      return;
    }

    const opt = t.closest('#CartDrawer .pf-vopt');
    if (opt) {
      event.preventDefault();
      if (opt.disabled || opt.classList.contains('is-selected')) return;
      const item = opt.closest('.pf-item');
      const d = pickerData(item);
      if (!d || !d.current) return;
      const i = parseInt(opt.dataset.index, 10);
      const combo = d.current.o.slice();
      combo[i] = opt.dataset.value;
      let target = d.variants.find((v) => v.a && v.o.every((x, k) => x === combo[k]));
      if (!target) target = d.variants.find((v) => v.a && v.o[i] === opt.dataset.value);
      if (!target) return;
      item.querySelectorAll('.pf-vopt[data-index="' + i + '"]').forEach((b) => b.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      swapVariant(d.pick, target.id);
      return;
    }

    if (!t.closest('.pf-vpanel')) closePanels();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanels(); });

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (!t || !t.closest) return;
    const toggle = t.closest('.pf-protect-toggle');
    if (!toggle) return;
    event.stopPropagation();
    run(async () => {
      if (toggle.checked) {
        await post('cart/update.js', { attributes: { _pf_protect_off: '' } });
        if (!toggle.dataset.key) await post('cart/add.js', { items: [{ id: parseInt(toggle.dataset.variantId, 10), quantity: 1 }] });
      } else {
        await post('cart/update.js', { attributes: { _pf_protect_off: '1' } });
        if (toggle.dataset.key) await post('cart/change.js', { id: toggle.dataset.key, quantity: 0 });
      }
    });
  }, true);

  function init() {
    fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fitAll, 120); });

    const cartRoot = document.getElementById('CartDrawer');
    if (!cartRoot) return;
    let queued = false;
    new MutationObserver((list) => {
      const relevant = list.some((m) =>
        m.type === 'childList' && (m.target === cartRoot || (m.target.classList && m.target.classList.contains('drawer__inner')))
      );
      if (!relevant || queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; onRender(); });
    }).observe(cartRoot, { childList: true, subtree: true });

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      let wasActive = drawer.classList.contains('active');
      new MutationObserver(() => {
        const active = drawer.classList.contains('active');
        if (active && !wasActive) { fitAll(); hold(); clearTimeout(playTimer); playTimer = setTimeout(play, 350); }
        if (!active) closePanels();
        wasActive = active;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    hold();

    // Bij laden: bescherming meteen goedzetten (toevoegen of verwijderen)
    const state = document.querySelector('#CartDrawer .pf-state');
    if (state) {
      const needAdd = state.dataset.count !== '0' && !state.dataset.protectKey && state.dataset.auto === '1';
      const needRemove = state.dataset.protectKey && state.dataset.protectOff === '1';
      if (needAdd || needRemove) refresh().catch(console.error);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.PFCartDrawer = { refresh, fit: fitAll };
})();